import { render } from "./level-9.vue?vue&type=template&id=7abc12c0&ts=true"
import script from "./level-9.vue?vue&type=script&lang=ts"
export * from "./level-9.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__